import { Col, Container, Row } from "react-bootstrap";
import BirdEyeImg from "../../assets/birdeye_icon.png";
import dexScreenImg from "../../assets/dex_screener_icon.png";
import dexToolsImg from "../../assets/dextools_icon.png";
import raydiumImg from "../../assets/raydium_icon.png";
import SolanaImg from "../../assets/solana_icon.png";
import "./AvailableOnSection.css";

function AvailableOnSection() {
  return (
    <section className="available_on_section">
      <h1 className="slide-down-fade-in"> Available On </h1>

      <Container fluid>
        <Row className="align-items-center">
          {[
            { src: SolanaImg, alt: "Platform 1", class: "avail1" },
            { src: dexToolsImg, alt: "Platform 2", class: "avail2" },
            { src: dexScreenImg, alt: "Platform 3", class: "avail3" },
            { src: raydiumImg, alt: "Platform 4", class: "avail4" },
            { src: BirdEyeImg, alt: "Platform 5", class: "avail5" }
          ].map((platform, index) => (
            <Col key={index}>
              <div className="platform-icon-wrapper">
                <img src={platform.src} alt={platform.alt} className={platform.class} />
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
}

export default AvailableOnSection;
